/**
 * Nel file properties sono censite tutte le voci di menù. Per ogni voce di menù sono indicati i ruoli che possono vedere quella voce di menù.
 * La voce di menù "timesheetApproval" ha indicati sia il ruolo da PM che TIMESHEET_APPROVER ma solo uno dei due può vedere questo menù.
 * La variabile determinante è "choose" che recupera da db l'impostazione
 */

import React, { useEffect, useState } from "react";
import { Layout, Skeleton, Menu } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { get, isEmpty } from "lodash";
import { showError } from "../../utils/utilities";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { setTimesheetApproval } from "../../redux/ducks/Section";
import { initFilters } from "../../redux/ducks/Filters";
import { setLoading } from "../../redux/ducks/Loading";
import SettingsApi from "../../services/api/Settings";
import { menuItems } from "../../utils/properties";

const { Sider } = Layout;

const MenuLeft = (props) => {
  const dispatch = useDispatch();
  const [userMenu, setUserMenu] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userInfo = useSelector((state) => get(state.userInfoDuck, "userInfo", {}));
  const section = useSelector((state) => get(state.sectionDuck, "menuLeft", { subMenuKey: "", menuKey: "" }));
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));

  const handleMenuClick = (menu) => {
    // dispatch(setSection({ menuLeft: sectionData }));
    dispatch(initFilters());
    navigate(menu.key);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    getMenuItems();
  }, [currentLanguage]);

  const menuByRoles = (menuItems, roles, choose) => {
    return menuItems.filter((menuItem) => {
      menuItem.label = t(`menuLeft.${menuItem.labelkey}`); // Label con traduzione
      // Se l'elemento ha figli, chiamata ricorsiva per filtrare i figli
      if (menuItem.children && menuItem.children.length > 0) {
        menuItem.children = menuByRoles(menuItem.children, roles, choose);
      }
      // Se l'elemento è 'timesheetApproval' e la role choose non è presente, non includerlo
      if (menuItem.key === "/timesheet-approval" && !roles.includes(choose) && !roles.includes("SYSTEM_IT")) {
        return false;
      }
      // Verifica che l'oggetto 'roles' esista prima di utilizzarlo
      const rolesContain = menuItem.roles?.some((role) => roles.includes(role));
      // Restituisci false se l'elemento ha children vuoti o se l'oggetto 'roles' non contiene alcuna delle roles da mantenere
      return rolesContain || (menuItem.children && menuItem.children.length > 0);
    });
  };

  const getMenuItems = async () => {
    dispatch(setLoading(true));
    const { data, error } = await SettingsApi.getSettings();
    if (!error && data) {
      dispatch(setTimesheetApproval({ timesheetApproval: get(data, "timesheetApprover", null) }));
      const menuItemsFiltered = menuByRoles(menuItems, userInfo.roles, data.timesheetApprover);
      setUserMenu(menuItemsFiltered);
    } else {
      showError(get(error, "messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  return (
    <Sider collapsedWidth="0" width="250" collapsed={props.change}>
      {isEmpty(userMenu) ? (
        <>
          <Skeleton.Input active size="small" className="mt-10 ml-10" />
          <br />
          <Skeleton.Input active size="small" className="mt-10 ml-10" />
          <br />
          <Skeleton.Input active size="small" className="mt-10 ml-10" />
          <br />
          <Skeleton.Input active size="small" className="mt-10 ml-10" />
        </>
      ) : (
        <Menu
          mode="inline"
          theme="dark"
          defaultOpenKeys={section.menuKey ? [section.menuKey] : []}
          defaultSelectedKeys={section.subMenuKey ? [section.subMenuKey] : []}
          items={userMenu}
          onClick={handleMenuClick}
        />
      )}
    </Sider>
  );
};

export default MenuLeft;
